module.exports = __webpack_public_path__ + "img/1.9683084f.png";